export default __webpack_public_path__ + "static/media/2002.592b8f70.png";